import { render, staticRenderFns } from "./BankIdSign.vue?vue&type=template&id=ceb0ae38&"
import script from "./BankIdSign.vue?vue&type=script&lang=js&"
export * from "./BankIdSign.vue?vue&type=script&lang=js&"
import style0 from "./BankIdSign.vue?vue&type=style&index=0&id=ceb0ae38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports